import React from "react";
import { useSelfie } from "~/components/auth/Auth";

import Redirect from "~/lib/route/Redirect";

import safeGetQueryParameter from "~/lib/utils/safeGetQueryParameter";
import { NextPage } from "next";
import NavbarLayout from "~/src/components/navbar/NavbarLayout";
import SignInPage from "~/src/components/auth/SignInPage";

interface ISignInProps {
  inviteToken?: string | null;
  redirectTo?: string | null;
}

const SignIn: NextPage<ISignInProps> = ({ inviteToken, redirectTo }) => {
  const user = useSelfie();

  if (user) {
    return <Redirect to={redirectTo || "/"} />;
  }

  return (
    <NavbarLayout pb={0} isLoggingIn={true}>
      <SignInPage inviteToken={inviteToken} />
    </NavbarLayout>
  );
};
export default SignIn;

SignIn.getInitialProps = ({ query }) => {
  return {
    inviteToken: safeGetQueryParameter(query, "token"),
    redirectTo: safeGetQueryParameter(query, "redirectTo"),
  };
};
